module.exports = __webpack_public_path__ + "static/media/vg.e1c461f7.svg";